// Figma file: https://www.figma.com/design/RLAwR3rK22mTGAOYui5uSQ/Web-Structure?node-id=598-3513&m=dev

import { ComponentProps, forwardRef } from "react"
import { Slot } from "@radix-ui/react-slot"
import { type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

import { buttonVariants } from "./consts"

export const Button = forwardRef<
  HTMLButtonElement,
  ComponentProps<"button"> &
    VariantProps<typeof buttonVariants> & {
      asChild?: boolean
    }
>(({ className, variant, size, square = false, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      ref={ref}
      data-slot="button"
      className={cn(buttonVariants({ variant, size, square }), className)}
      {...props}
    />
  )
})

Button.displayName = "Button"
